import React from "react";
import CommonDataTable from "../../../components/Datatable/CommonDataTable";
import Badge from "../../../components/Common/Badge";
import { handleChangeTableCheckbox } from "../../../helpers/handleFormChanges";
import ButtonRounded from "../../../components/buttons/ButtonRounded";
import Format from "../../../helpers/Format";
import PropTypes from "prop-types";

function EnvioDataTable({ linhas, checkboxesMarcadosHook, togEnviarModal }) {
  const { checkboxesMarcados, setCheckboxesMarcados } = checkboxesMarcadosHook;

  const handleCheckAll = () => {
    if (checkboxesMarcados.length < linhas.length) {
      const novosCheckboxesMarcados = linhas.map((linha) => String(linha.uid));
      setCheckboxesMarcados(novosCheckboxesMarcados);
    } else setCheckboxesMarcados([]);
  };

  const colunas = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "uid",
        disableSortBy: true,
        Cell: ({ row }) => (
          <input
            key={`checkbox-${row.original.uid}`}
            className="form-check-input"
            type="checkbox"
            name="nfs"
            value={row.original.uid}
            checked={checkboxesMarcados.includes(String(row.original.uid))}
            onChange={(e) => {
              handleChangeTableCheckbox(
                e,
                checkboxesMarcados,
                setCheckboxesMarcados
              );
            }}
          />
        ),
      },
      {
        Header: "Razão social",
        accessor: "razao_social",
        isSorted: true,
      },
      {
        Header: "CNPJ",
        disableSortBy: true,
        accessor: (row) => {
          return Format.formatCNPJCPF(row.cnpj);
        },
      },
      {
        Header: "Nome do contato",
        accessor: "contato",
        disableSortBy: true,
      },
      {
        Header: "Número do contato",
        accessor: (row) => {
          return Format.formataCelular(row.celular || "");
        },
        disableSortBy: true,
      },
    ],
    [checkboxesMarcados, setCheckboxesMarcados]
  );

  return (
    <CommonDataTable
      colunas={colunas}
      linhas={linhas}
      botoes={
        <>
          <button
            className="btn btn-outline-info btn-rounded mb-2"
            onClick={() => {
              handleCheckAll();
            }}
          >
            Selecionar todas{" "}
            <Badge
              color="info"
              style={{ borderRadius: "30px", padding: "4px 6px" }}
            >
              {checkboxesMarcados.length}/{linhas.length}
            </Badge>
          </button>
          <ButtonRounded
            color="success"
            onClick={() => {
              togEnviarModal();
            }}
          >
            Enviar WhatsApp
          </ButtonRounded>
        </>
      }
    />
  );
}

EnvioDataTable.propTypes = {
  linhas: PropTypes.arrayOf(PropTypes.object).isRequired,
  checkboxesMarcadosHook: PropTypes.shape({
    checkboxesMarcados: PropTypes.arrayOf(PropTypes.string).isRequired,
    setCheckboxesMarcados: PropTypes.func.isRequired,
  }).isRequired,
  togEnviarModal: PropTypes.func.isRequired,
  row: PropTypes.object,
};

export default EnvioDataTable;
